import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import b2bRoles from '../../ContentConfig/b2bRoles';
import { __ } from '../../Utils';
import Detail from '../Settings/Users/Detail';
import Settings from '../Settings/Portal';
import { connect } from '../../Store';

const Wrapper = styled.div``;

const LoginInfoWrapper = styled.div`
  margin-left: 16px;
  margin-right: 16px;
  margin-top: 16px;
  background: #eee;
  padding: 16px;
`;

const Title = styled.div`
  font-size: ${rem(26)};
  font-weight: 400;
  color: #434245;
  margin-bottom: ${rem(10)};
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  font-size: ${rem(14)};
  margin-bottom: ${rem(8)};
`;

const Label = styled.div`
  display: flex;
  color: #434245;
  margin-right: ${rem(8)};
  font-weight: bold;
`;

const Text = styled.div`
  font-size: ${rem(14)};
  color: #70af00;
  font-weight: 600;
`;

class AccountDetail extends React.Component {
  render() {
    return (
      <Wrapper>
        <LoginInfoWrapper>
          <Title>{__('Prihlásovacie údaje')}</Title>
          <Row>
            <Label>{__('Ste prihlásený pod účtom:')}</Label>
            <Text>{this.props.user.email}</Text>
          </Row>

          <Row>
            <Label>{__('Vaše práva:')}</Label>
            <Text>
              {b2bRoles.find(b => b.value === this.props.user.role)
                ? b2bRoles.find(b => b.value === this.props.user.role).label
                : '-'}
            </Text>
          </Row>
        </LoginInfoWrapper>
        <Detail myAccount id={this.props.user._id} />

        <LoginInfoWrapper style={{ minHeight: rem(400) }}>
          <Title>{__('Nastavenia portálu')}</Title>
          <Settings />
        </LoginInfoWrapper>
      </Wrapper>
    );
  }
}

AccountDetail.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    surname: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    role: PropTypes.string,
  }),
};

AccountDetail.defaultProps = {
  user: {
    name: '',
    surname: '',
    email: '',
    phone: '',
    role: '',
  },
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(AccountDetail);



// WEBPACK FOOTER //
// ./src/Containers/AccountDetails/index.jsx